var map = {
	"./books-blue.png": 612,
	"./cancel-blue.png": 613,
	"./clock-blue.png": 614,
	"./flag-blue.png": 615,
	"./gauge-blue.png": 616,
	"./lightbulb-blue.png": 617,
	"./rising-blue.png": 618
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 709;



//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons ^\.\/.*\-blue\.png$
// module id = 709
// module chunks = 0